import { createSlice } from '@reduxjs/toolkit';

import type { Freebets } from '../../types';

import { getFreebets } from '../../actions';
import { sortByAmountAndExpirationDate } from '../../utils/sort-by-amount-and-expiration-date';

export const initialState: Freebets = {
  data: null,
  loading: false,
  requested: false,
  error: null,
};

export const freebetsSlice = createSlice({
  name: 'freebets',
  initialState,
  reducers: {
    cleanup: () => {
      return initialState;
    },
    setFreebets: (state, action) => {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFreebets.pending, (state) => {
        state.loading = true;
        state.requested = false;
        state.error = null;
      })
      .addCase(getFreebets.fulfilled, (state, action) => {
        state.loading = false;
        state.requested = true;

        state.data = sortByAmountAndExpirationDate(action.payload.data);
      })
      .addCase(getFreebets.rejected, (state, action) => {
        state.loading = false;
        state.requested = true;

        if (action.error.message) {
          state.error = action.error.message;
        }
      });
  },
});

export const { reducer: freebetsReducer, actions: freebetsActions } = freebetsSlice;

export const { setFreebets, cleanup } = freebetsActions;
